__turbopack_context__.v({
  "errorMessage": "WeeklyDrawPurchase-module__NPulJW__errorMessage",
  "leftAlign": "WeeklyDrawPurchase-module__NPulJW__leftAlign",
  "morePadding": "WeeklyDrawPurchase-module__NPulJW__morePadding",
  "pageContainer": "WeeklyDrawPurchase-module__NPulJW__pageContainer",
  "titleContainer": "WeeklyDrawPurchase-module__NPulJW__titleContainer",
  "underlineLink": "WeeklyDrawPurchase-module__NPulJW__underlineLink",
});
